import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';


import { PrintDistributionComponent } from "./print-distribution.component";
import { PrintDistributionService } from "./service/print-distribution.service";
import { SharedModule } from 'client/app/shared';


@NgModule({
  declarations: [PrintDistributionComponent],
  providers: [
    PrintDistributionService
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatExpansionModule,
    MatPaginatorModule,
    BrowserModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    BrowserAnimationsModule
  ]
})
export class PrintDistributionModule {


}
